import { HttpStatus } from '@diritto/common/utils/requester/httpStatus';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { AccountApi } from 'api/ApiHelper';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import { accountsQueryKey } from 'queries/account/queryKey';

const request = (options?: AxiosRequestConfig) => async () => {
  try {
    return await AccountApi.me(options);
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (e.response?.status === HttpStatus.UNAUTHORIZED) {
        return null;
      }
    }
    throw e;
  }
};

export const useGetAccountMeQuery = () =>
  useQuery({
    queryKey: accountsQueryKey.user,
    queryFn: request(),
    staleTime: 1000 * 60 * 50,
    refetchInterval: 1000 * 60 * 30,
  });

export const prefetchAccountMeQuery = async (queryClient: QueryClient, options: AxiosRequestConfig) =>
  queryClient.prefetchQuery({
    queryKey: accountsQueryKey.user,
    queryFn: request(options),
    staleTime: 1000 * 60 * 50,
    gcTime: 0,
  });

export const fetchAccountMeQuery = async (queryClient: QueryClient, options?: AxiosRequestConfig) =>
  queryClient.fetchQuery({
    queryKey: accountsQueryKey.user,
    queryFn: request(options),
    staleTime: 1000 * 60 * 50,
    gcTime: 0,
  });
